<template>
  <div class="container">
    <h4 class="title">News</h4>
    <div class="news-created-list">
      <div class="news-box">
        <app-news v-for="(item, index) in newsExtend" :key="index" :item="item"></app-news>
      </div>
    </div>
    <BottomSection></BottomSection>
  </div>
</template>
<script>
import News from "@/components/shared/News";

const url = process.env.VUE_APP_URL;

const BottomSection = () => import("@/components/shared/BottomSection");
export default {
  props: {
    name,
  },
  computed: {
    newsExtend() {
      var news = this.$store.getters.news,
        newsMas = [];
      if (this.name === "photo") {
        news.filter((el) => {
          if (el.videoLink === null) {
            newsMas.push(el);
          }
        });
      } else {
        news.filter((el) => {
          if (el.videoLink !== null) {
            newsMas.push(el);
          }
        });
      }
      return newsMas;
    },
  },
  methods: {
    setNews() {
      this.axios
        .get(url + "/articles", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          return this.$store.dispatch("setNews", payload);
        });
    },
  },
  mounted() {
    this.setNews();
  },
  components: {
    "app-news": News,
    BottomSection,
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 9.5rem;
  padding-bottom: 9rem;
  h4 {
    margin-bottom: 6.5rem;
  }
}
</style>